<template>
  <div>
    <div id="big_parallax">
      <agile ref="main" :options="options1" :as-nav-for="asNavFor1" class="mainview">
      <div class="slide" v-for="(slide, index) in slides" :key="index" :class="`slide--${index}`">
        <img :src="slide">
      </div>
      </agile>
      <agile ref="thumbnails" :options="options2" :as-nav-for="asNavFor2" class="thumbnails">
        <div class="slide slide--thumbniail" v-for="(slide, index) in slides" :key="index" @click="$refs.thumbnails.goTo(index);" :class="`slide--${index}`">
          <img :src="slide">
        </div>
      </agile>
    </div>
    <div class="home_content_wall">
      <div class="wrapper_2 clearfix">
        <Main></Main>
        <Sidemenu></Sidemenu>
      </div>
    </div>
  </div>
</template>

<script>
import Main from "./top_main.vue";
import Sidemenu from "./sidemenu.vue";
import { VueAgile } from 'vue-agile';
export default {
  components:{
    agile: VueAgile,
    Main,
    Sidemenu
  },
  data(){
    return{
      asNavFor1: [],
       asNavFor2: [],
       slides: [
         'https://i.gyazo.com/f4ace623af205e4dc1d675414aada3d8.jpg',//熱海旅行2022の外
         'https://i.gyazo.com/96ce807cd780e99a36a9ec55b5e8a77b.jpg',//熱海旅行2022クルージング
         'https://i.gyazo.com/56789b76e67fcda8b5d836c51b1f6da1.jpg',//熱海旅行2022バーベキュー
         'https://i.gyazo.com/f545722ed9197d4bb095e39eb9eb88f2.jpg',//熱海旅行2022宿で
         'https://i.gyazo.com/3c880da7ebe451e38ea1df480956274a.jpg',//OBとの集合写真2022
         'https://i.gyazo.com/842fd7172f0434c1844638bfe9b44797.jpg',//練習風景
         'https://i.gyazo.com/282c1d3a5f8303b46c8aeb88956b561e.jpg'//トレーニング風景
       ],
       options1: {
         dots: false,
         fade: true,
         navButtons: false
       },
       options2: {
         autoplay: true,
         centerMode: true,
         dots: false,
         navButtons: false,
         slidesToShow: 3,
         responsive: [
           {
             breakpoint: 600,
             settings: {
               slidesToShow: 5
             }
           },
           {
             breakpoint: 1000,
             settings: {
               navButtons: true
             }
           }
         ]
       }
    };
  },
  mounted(){
    this.asNavFor1.push(this.$refs.thumbnails);
    this.asNavFor2.push(this.$refs.main);
  }
};
</script>

<style scoped>
#big_parallax{
  width:100%;
  position: fixed;
  top:0;
  z-index:1;
  background-color:#EEEEEE;
}

.mainview{
  margin-bottom:10px;
}

.thumbnails {
  margin: 0 -5px;
  width: calc(100% + 10px);
}

.slide {
  -webkit-box-align: center;
  align-items: center;
  box-sizing: border-box;
  color: #fff;
  display: -webkit-box;
  display: flex;
  height: 570px;
  -webkit-box-pack: center;
  justify-content: center;
}

.slide--thumbniail {
  cursor: pointer;
  height: 130px;
  padding: 0 5px;
  -webkit-transition: opacity 0.3s;
  transition: opacity 0.3s;
}

.slide--thumbniail:hover {
  opacity: 0.75;
}

.slide img {
  height: 100%;
  -o-object-fit: cover;
     object-fit: cover;
  -o-object-position: center;
     object-position: center;
  width: 100%;
}

.home_content_wall{
  width: 100%;
  background-color:#EEEEEE;
  z-index: 3;
  position: relative;
}

.wrapper_2{
  width:970px;
  margin:710px auto 0;
  padding-top:35px;
  position: relative;
  z-index:3;
}

@media  (min-width: 500px) and (max-width:1000px){
.wrapper_2{
  width:100%;
  margin:0 0 0;
  padding-top:1px;
}

.home_content_wall{
  margin-top:710px;
}
}

@media (min-width: 500px) and (max-width:899px){
.slide{
  height:432px;
}

.slide--thumbniail{
  height:85px;
}

.home_content_wall{
  margin-top:527px;
}
}

@media (max-width:499px) {
.wrapper_2{
  width:100%;
  margin:0 0;
  padding-top:0;
  position: relative;
  z-index:3;
}

#big_parallax{
  background-color:black;
}

.mainview{
  margin-top:122px;
}

.slide{
  height:210px;
}

.slide--thumbniail{
  height:73px;
}

.home_content_wall{
  margin-top:415px;
}
}
</style>
